/**
 * Settings state atoms
 */
import { atom } from 'jotai';

import { DEFAULT_USER_SETTINGS } from '@/lib/settingsUtils';
import type { UserSettings } from '@/types/card';

// ============================================================================
// Settings State Atom
// ============================================================================

export interface SettingsState {
  data: UserSettings | null | undefined;
  isLoading: boolean;
  error: Error | null;
}

/** Atom holding the user settings - populated by sync, updated by subscription */
export const settingsStateAtom = atom<SettingsState>({
  data: undefined,
  isLoading: true,
  error: null,
});

/** Export default settings for convenience */
export { DEFAULT_USER_SETTINGS };
